export const tabs = [
  { label: 'Home', value: 'home' },
  { label: 'Files', value: 'files' },
  { label: 'Shipments', value: 'shipments' },
  { label: 'Contacts', value: 'contacts' },
  { label: 'Emails', value: 'emails' },
  { label: 'Finances', value: 'finances' },
  { label: 'Notes', value: 'notes' },
]
